<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col :span="6" style="padding-top: 10px;">
          <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-table :data="levels" tooltip-effect="dark" style="width: 100%; margin-bottom:60px;"  v-loading.body="fetchLevelsLoading">
        <el-table-column prop="level" :label="generateCustomizeString('level')" width="140">
        </el-table-column>
        <el-table-column prop="name" :label="generateCustomizeString('levelName')" v-if="this.$i18n.locale == 'zh'">
        </el-table-column>
        <el-table-column prop="enName" :label="generateCustomizeString('levelName')" v-if="this.$i18n.locale == 'en'">
        </el-table-column>
        <el-table-column :label="generateCustomizeString('operate')" width="100">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row.level)" type="text" size="small">{{generateCustomizeString('edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog :title="generateCustomizeString('editName')" :visible.sync="editDialogVisiable" width="40%" :append-to-body="true">
      <el-form ref="form" :model="form" :rules="rules" label-width="25%" class="detailForm">
        <el-form-item :label="generateCustomizeString('levelName')" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onConfirmEditName">{{generateCustomizeString('save')}}</el-button>
          <el-button @click="onCancel">{{generateCustomizeString('cancel')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'LevelList',
  data() {
    return {
      levels: [],
      fetchLevelsLoading: false,
      rules: {
        name: [
          {
            required: true,
            min: 2,
            max: 64,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      },
      form: {
        name: ''
      },
      currentEditLevel: null,
      fetchUpdateLevelNameLoading: false,
      editDialogVisiable: false
    }
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      this.fetchLevels()
    },
    onEdit(level) {
      this.currentEditLevel = level
      this.editDialogVisiable = true
    },
    onCancel() {
      this.$refs.form.resetFields()
      this.editDialogVisiable = false
    },
    onConfirmEditName() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.fetchUpdateLevelName(this.currentEditLevel, this.form)
        } else {
          this.$message.error(this.generateCustomizeString('dataError'))
        }
      })
    },
    fetchUpdateLevelName(level, data) {
      if (this.fetchUpdateLevelNameLoading) return
      this.fetchUpdateLevelNameLoading = true
      request({
        url: `discount/level/${level}`,
        method: 'patch',
        data
      }).then(response => {
        this.fetchLevels()
        this.currentEditLevel = null
        this.editDialogVisiable = false
        this.fetchUpdateLevelNameLoading = false
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.fetchUpdateLevelNameLoading = false
      })
    },
    fetchLevels() {
      if (this.fetchLevelsLoading) return
      this.fetchLevelsLoading = true
      request({
        url: 'discount/level/list',
        method: 'get'
      }).then(response => {
        this.levels = response.data
        for (var i = 0; i < this.levels.length; i++) {
          switch (this.levels[i].name) {
            case '青铜':
              this.levels[i].enName = this.generateCustomizeString('青铜')
              break
            case '白银':
              this.levels[i].enName = this.generateCustomizeString('白银')
              break
            case '黄金':
              this.levels[i].enName = this.generateCustomizeString('黄金')
              break
            case '铂金':
              this.levels[i].enName = this.generateCustomizeString('铂金')
              break
            case '钻石':
              this.levels[i].enName = this.generateCustomizeString('钻石')
              break
            case '星耀':
              this.levels[i].enName = this.generateCustomizeString('星耀')
              break
            case '王者':
              this.levels[i].enName = this.generateCustomizeString('王者')
              break
            default:
              this.levels[i].enName = this.levels[i].name
          }
        }
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.fetchLevelsLoading = false
      })
    }
  },
  created() {
    this.fetchLevels()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .el-header,
  .el-footer {
    background-color: #eee;
    color: #333;
  }
</style>
